import { fetchFromRTM } from '../RTMResolvers';
import { RTM_GRAPHQL_QUERY_OK, RTM_GRAPHQL_QUERY_ERROR, RTM_GRAPHQL_QUERY } from '../coursewareItem/constants';
import CoursewareItemProvider from '../coursewareItem/CoursewareItemProvider';

export default class PluginQueryService {
  interpolateQuery(queryFragment) {
    const { cohortId, deploymentId } = CoursewareItemProvider.getDeploymentContext();
    return `
    query {
      learn {
        cohort (cohortId: "${cohortId}") {
          deployment (deploymentId: "${deploymentId}") {
            ${queryFragment}
          }
        }
      }
    }
    `;
  }

  async executeQuery(queryFragment) {
    try {
      const message = {
        type: RTM_GRAPHQL_QUERY,
        query: this.interpolateQuery(queryFragment.query),
        parameters: {},
      };

      const response = await fetchFromRTM(
        message,
        RTM_GRAPHQL_QUERY_OK,
        RTM_GRAPHQL_QUERY_ERROR,
      );

      return response;
    } catch (error) {
      throw new Error(`failed to run query: ${error.message}`);
    }
  }

  static build() {
    return new PluginQueryService();
  }
}
